/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TabularMLDataset } from './TabularMLDataset';
import { TabularMLDatasetFromJSON, TabularMLDatasetFromJSONTyped, TabularMLDatasetToJSON } from './TabularMLDataset';

/**
 *
 * @export
 * @interface PaginatedTabularMLDatasetList
 */
export interface PaginatedTabularMLDatasetList {
  /**
   *
   * @type {number}
   * @memberof PaginatedTabularMLDatasetList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedTabularMLDatasetList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedTabularMLDatasetList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<TabularMLDataset>}
   * @memberof PaginatedTabularMLDatasetList
   */
  results: Array<TabularMLDataset>;
}

/**
 * Check if a given object implements the PaginatedTabularMLDatasetList interface.
 */
export function instanceOfPaginatedTabularMLDatasetList(value: object): value is PaginatedTabularMLDatasetList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedTabularMLDatasetListFromJSON(json: any): PaginatedTabularMLDatasetList {
  return PaginatedTabularMLDatasetListFromJSONTyped(json, false);
}

export function PaginatedTabularMLDatasetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedTabularMLDatasetList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(TabularMLDatasetFromJSON),
  };
}

export function PaginatedTabularMLDatasetListToJSON(value?: PaginatedTabularMLDatasetList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(TabularMLDatasetToJSON),
  };
}
